import certificateKruDew21Day from '../assets/images/cert/certificate-krudew-21day.pdf';
import certEnglishGrammar from '../assets/images/cert/cert-english-grammar.png';
import certEnglishB1 from '../assets/images/cert/cert-english-work.png';
import cert21DayPreview from '../assets/images/cert/cert-21-day-img.png';
import certEnglishForDailyLife from '../assets/images/cert/cert-english-for-daily-life.png';

const certificates = [
  {
    date: 'May 2026',
    name: 'English Grammar for Work and Business',
    nameTh: 'English Grammar for Work and Business',
    issuer: 'Tokota Co., Ltd. (supported by depa)',
    issuerTh: 'บริษัท ต๊อกโตะ จำกัด (สนับสนุนโดย depa)',
    credentialUrl: certEnglishGrammar,
  },
  {
    date: 'June 2026',
    name: 'English Communication for Work & Business',
    nameTh: 'English Communication for Work & Business',
    issuer: 'Tokota Co., Ltd. (supported by depa)',
    issuerTh: 'บริษัท ต๊อกโตะ จำกัด (สนับสนุนโดย depa)',
    credentialUrl: certEnglishB1,
  },
  {
    date: 'July 2026',
    name: '21-Day Challenge Course (CEFR B1 Level)',
    nameTh: '21-Day Challenge Course (CEFR B1 Level)',
    issuer: 'Opendurian Co., Ltd. (Kru Dew)',
    issuerTh: 'บริษัท โอเพ่นดูเรียน จำกัด (ครูดิว)',
    credentialUrl: certificateKruDew21Day,
    previewUrl: cert21DayPreview,
  },
  {
    date: 'July 2026',
    name: 'English for Daily Life Communication',
    nameTh: 'English for Daily Life Communication',
    issuer: 'Tokota Co., Ltd. (supported by depa)',
    issuerTh: 'บริษัท ต๊อกโตะ จำกัด (สนับสนุนโดย depa)',
    credentialUrl: certEnglishForDailyLife,
    previewUrl: certEnglishForDailyLife,
  },
];

export default certificates;
